//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeSheetsStatus', {
//        templateUrl: 'views/components/views/timeSheetsStatus/timeSheetsStatus.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'timeSheetsStatusService', 'rememberService', function (stateService, utilityService, timeSheetsStatusService, rememberService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                date_fom: '',
//                date_tom: '',
//                dateselector_index: ''
//            };

//            vm.model = {
//                filterValueButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
//                ],
//                setting: {},
//                itemsListStatuses: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await timeSheetsStatusService.getSetting())[0];
//            }
            
//            async function loadStatuses() {
//                if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.dateselector_index) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) return;

//                return vm.model.itemsListStatuses = await timeSheetsStatusService.listStatuses(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'date_fom':
//                    case 'date_tom':
//                    case 'dateselector_index':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD DATE RANGE CHANGE FUNCTION

//            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
//                vm.model.setting.date_fom = startDate;
//                vm.model.setting.date_tom = endDate;
//                vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

//                if (vm.model.setting.date_fom) rememberFunc('date_fom');
//                if (vm.model.setting.date_tom) rememberFunc('date_tom');
//                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');
//                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) loadStatuses();
//            }

//            // #endregion FIELD DATE RANGE CHANGE FUNCTION

//            // #region RELOAD FUNCTION

//            function reloadStatuses() {
//                setTimeout(() => {
//                    if (vm.model.setting.timer_on === '1') {
//                        reloadStatuses();
//                        loadStatuses();
//                    }
//                }, 30000);
//            }

//            reloadStatuses();

//            // #endregion RELOAD FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadStatuses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
